import axios from "axios";
import { errorMessageFromResponse } from "../constants/commonFunctions";
import { handleErrorMessage } from "./classes";


export const SAVE_JOB = "SAVE_JOB";
export const UNSAVE_JOB = "UNSAVE_JOB";

export const ADD_TO_PROGRESS = "ADD_TO_PROGRESS";
export const REMOVE_FROM_PROGRESS = "REMOVE_FROM_PROGRESS";

export const ADD_TO_APPLIED = "ADD_TO_APPLIED";
export const REMOVE_FROM_APPLIED = "REMOVE_FROM_APPLIED";

export const ADD_TO_ARCHIVED = "ADD_TO_ARCHIVED";
export const REMOVE_FROM_ARCHIVED = "REMOVE_FROM_ARCHIVED";



export function postProfileData(filterData, action) {
  return async (dispatch) => {
    const headers = {
      Authorization: `Token ${localStorage.getItem("token")}`,
    };

    return axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/filters/dashboard/`,
        filterData,
        { headers: headers }
      )
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          dispatch({
            type: action,
            payload: res.data?.data,
          });
          return { val: true };
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}

export function getProfileDropDown(action) {
  return async (dispatch) => {
    const headers = {
      Authorization: `Token ${localStorage.getItem("token")}`,
    };

    return axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/filters/drop_down/`,
        { headers: headers }
      )
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          dispatch({
            type: action,
            payload: res.data?.data,
          });
          return { val: true };
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}

export const saveJob=(job)=>({
type:SAVE_JOB,
payload:job
})

export const unsaveJob=(jobid)=>({
type:UNSAVE_JOB,
payload:jobid
})


export const addToProgress = (job) => ({ 
    type: ADD_TO_PROGRESS,
    payload: job 
  });
export const removeFromProgress = (id) => ({
   type: REMOVE_FROM_PROGRESS,
   payload: id 
  });


export const addToApplied = (job) => ({
   type: ADD_TO_APPLIED,
    payload: job 
  });
export const removeFromApplied = (id) => ({ 
  type: REMOVE_FROM_APPLIED, 
  payload: id
 });


export const addToArchived = (job) => ({ 
  type: ADD_TO_ARCHIVED, 
  payload: job
 });
export const removeFromArchived = (id) => ({
   type: REMOVE_FROM_ARCHIVED, 
   payload: id 
  });
